import { withRouter } from "react-router-dom";
import { HeaderComponent } from "./header.component";
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import styles from './styles';
import {Layout} from '@components/layout';
import {Auth} from '@components/auth';
import {compose} from 'redux';

const mapStateToProps = (state, props) => ({
    context: state.context || {},
    isSidebarOpened: state.layout.sidebar.isOpened || false,
    isSocketConnected: state.layout.socket.connected,
});

const actions = {
    openSidebar: Layout.actions.openSidebar,
    closeSidebar: Layout.actions.closeSidebar,
    getUserContext: Auth.actions.getUserContext,
    setInitialContext: Auth.actions.setInitialContext,
};

export const HeaderContainer = connect(mapStateToProps, actions)(
    compose(
        withRouter,
        withStyles(styles)
    )(HeaderComponent)
);
